import { useState } from 'react';
import dynamic from 'next/dynamic';

import { TranslationService } from '@/utils/services/TranslationService';

import useCollaborationNotifications from '@/hooks/swr/useCollaborationNotifications';
import useSchedulerRestrictions from '@/utils/hooks/swr/scheduler/useSchedulerRestrictions';
import { useNewFunnelActivated } from '@/utils/scheduler/funnel/hooks/useNewFunnelActivated';

//hooks
import useToggle from '@/utils/hooks/utils/useToggle';

import { SCHEDULER_COLLABORATION_NOTIFICATIONS } from '@/lib/routes/privateRoutes';

// Components
import CollaborationWrapper from '@/components/pages/scheduler/collaboration/CollaborationWrapper';
import CollaborationNotificationsFeed from '@/components/pages/scheduler/collaboration/notifications/CollaborationNotificationsFeed';
import CollaborationNotificationsHeader from '@/components/pages/scheduler/collaboration/notifications/CollaborationNotificationsHeader';

const FunnelModal = dynamic(() => import('@/components/pages/scheduler/PostFunnel/FunnelModal'));
const SchedulerFunnel = dynamic(() =>
    import('@/components/composite/Scheduler/Funnel').then((mod) => mod.SchedulerFunnel)
);

const PageContent = () => {
    const { isNewFunnel } = useNewFunnelActivated();
    useSchedulerRestrictions();

    const {
        notifications,
        notificationsError,
        isLoadMore,
        // Loaders
        isLoadingMore,
        isLoadingInitialData,
        isValidating,
        // Functions
        mutateNotifications,
        setRequestParams,
        loadMoreNotifications
    } = useCollaborationNotifications({
        limit: 20
    });
    const {
        isOpen: isOpenPostFunnel,
        toggle: togglePostFunnel,
        params: paramsPostFunnel,
        setParams: setParamsPostFunnel
    } = useToggle();
    const [checkedIds, setCheckedIds] = useState([]);

    const openFunnel = (params) => {
        if (isNewFunnel) {
            setParamsPostFunnel({
                type: 'edit',
                postId: params.postId,
                socialProfileId: params.socialProfileId
            });
            return togglePostFunnel();
        }

        setParamsPostFunnel(params);
        togglePostFunnel();
    };

    return (
        <>
            <CollaborationNotificationsHeader
                setRequestParams={setRequestParams}
                mutateNotifications={mutateNotifications}
                checkedIds={checkedIds}
                setCheckedIds={setCheckedIds}
                notifications={notifications}
                isValidating={!isLoadingInitialData && !isLoadingMore && isValidating}
            />
            <CollaborationNotificationsFeed
                notifications={notifications}
                notificationsError={notificationsError}
                isLoadMore={isLoadMore}
                isLoadingMore={isLoadingMore}
                isLoadingInitialData={isLoadingInitialData}
                mutateNotifications={mutateNotifications}
                loadMoreNotifications={loadMoreNotifications}
                checkedIds={checkedIds}
                setCheckedIds={setCheckedIds}
                openFunnel={openFunnel}
            />
            {isNewFunnel ? (
                <SchedulerFunnel
                    isOpen={isOpenPostFunnel}
                    toggle={togglePostFunnel}
                    settings={paramsPostFunnel}
                    callbackSuccess={() => mutateNotifications()}
                />
            ) : (
                <FunnelModal
                    isOpen={isOpenPostFunnel}
                    toggle={() => {
                        setParamsPostFunnel(null);
                        togglePostFunnel();
                    }}
                    params={paramsPostFunnel}
                    callbackSuccessSubmitPost={() => mutateNotifications()}
                />
            )}
        </>
    );
};

const Notifications = () => (
    <CollaborationWrapper>
        <PageContent />
    </CollaborationWrapper>
);
export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(
    SCHEDULER_COLLABORATION_NOTIFICATIONS
);

export default Notifications;
